import ApplicationController from './application_controller'

export default class extends ApplicationController {
    connect () {
        super.connect()

        // add your code here, if applicable
        const timeTableDiv = document.getElementById("timeTableDiv")
        const table = timeTableDiv?.querySelector("table")

        document.addEventListener('click', e =>{ 
            const tds = document.querySelectorAll(".js-notes-td")
            if (e.target.querySelector(".js-ipt")) return
            tds.forEach(td => {
                console.log(td == e.target)
                if (td == e.target) {
                    td.insertAdjacentHTML('beforeend', this.getInputAndButtons());
                    td.querySelector("input").focus()
                } 
            })
            
            
            let buttonClick = false
            if(e.target.classList.contains("js-save")) {
                buttonClick = true
                const data = {
                    title: e.target.closest('td.js-notes-td').querySelector(".js-ipt").value, 
                    date: e.target.closest('td.js-notes-td').dataset.date, 
                    time: e.target.closest('td.js-notes-td').dataset.time, 
                    kind: "notes"}
                this.stimulate("Notes#create_note", data.title, data.date, data.time, data.kind )
            }
            if(e.target.classList.contains("js-cancel")) {
                buttonClick = true
            }

            this.removeInputs(e.target.closest('td.js-notes-td'),buttonClick)
        })
      }
    openNoteInput(e) {

    }

    removeInputs(td, buttonClick) {
        const ipts =  document.querySelectorAll(".js-ipt-box")
        ipts.forEach(ipt => {
            if (!td || buttonClick || td.querySelector('.js-ipt-box') != ipt) ipt.remove()
        })  
    }

    getInputAndButtons() {
        const html = `
        <div class="js-ipt-box input-box">
            <input class='js-ipt input w-100'>
            <div class='input-box__float-buttons'>
                <button type="button" class="btn small js-save">שמירה</button>
                <button type="button" class="btn small js-cancel">ביטול</button>
            </div>
        </div>
        `
        return html
    }

    setDateParam(e) {
		let url = new URL(window.location.href);
		let params = new URLSearchParams(url.search);
		url.searchParams.set('date', e.target.value);
		window.history.pushState("", "", url);
	}

    close(){
		const modal = document.querySelector(".modal-wrapper")
		modal.classList.add("inactive")
		setTimeout(() => {
			console.log(12)

			modal.style.display = 'none'
			document.querySelector("#calendar-modal-content").innerHTML = ''
			document.body.style.overflow = 'auto'
		}, 200);
	}
	
	showNotePopup(event) {
		// Don't show popup on mobile/tablet (touch devices)
		if (window.innerWidth <= 1024) {
			return
		}
		
		const noteItem = event.currentTarget
		const popup = noteItem.querySelector('.note-popup')
		if (popup) {
			// Clear any existing timeout
			if (noteItem._popupTimeout) {
				clearTimeout(noteItem._popupTimeout)
				noteItem._popupTimeout = null
			}
			
			// Temporarily show popup to measure it
			popup.style.display = 'block'
			const popupRect = popup.getBoundingClientRect()
			const rect = noteItem.getBoundingClientRect()
			const popupHeight = popupRect.height
			const popupWidth = popupRect.width
			const spaceAbove = rect.top
			const spaceBelow = window.innerHeight - rect.bottom
			const spaceRight = window.innerWidth - rect.right
			const spaceLeft = rect.left
			
			// Reset classes
			popup.classList.remove('popup-below', 'popup-left')
			
			// If there's not enough space above but enough below, position popup below
			if (spaceAbove < popupHeight + 20 && spaceBelow > popupHeight + 20) {
				popup.classList.add('popup-below')
			}
			
			// If popup would go off right edge, align to left
			if (spaceRight < popupWidth && spaceLeft > popupWidth) {
				popup.classList.add('popup-left')
			}
			
			// Keep popup visible
			popup.style.display = 'block'
		}
	}
	
	hideNotePopup(event) {
		const noteItem = event.currentTarget
		const popup = noteItem.querySelector('.note-popup')
		if (popup) {
			// Check if mouse is moving to the popup
			const relatedTarget = event.relatedTarget
			if (relatedTarget && (popup.contains(relatedTarget) || popup === relatedTarget)) {
				// Mouse is moving to popup, keep it open
				return
			}
			
			// Delay hiding to allow smooth transition
			noteItem._popupTimeout = setTimeout(() => {
				// Double check that mouse is not on note item or popup
				if (!noteItem.matches(':hover') && !popup.matches(':hover')) {
					popup.style.display = 'none'
				}
			}, 100)
		}
	}
	
	keepPopupOpen(event) {
		// Keep popup open when mouse enters it
		const popup = event.currentTarget
		const noteItem = popup.closest('.note-item')
		if (noteItem && noteItem._popupTimeout) {
			clearTimeout(noteItem._popupTimeout)
			noteItem._popupTimeout = null
		}
	}
	
	hideNotePopupFromPopup(event) {
		// Hide popup when mouse leaves the popup itself
		const popup = event.currentTarget
		const noteItem = popup.closest('.note-item')
		
		// Check if mouse is moving back to note item
		const relatedTarget = event.relatedTarget
		if (relatedTarget && (noteItem && noteItem.contains(relatedTarget))) {
			// Mouse is moving back to note item, keep it open
			return
		}
		
		// Hide the popup
		setTimeout(() => {
			if (!noteItem.matches(':hover') && !popup.matches(':hover')) {
				popup.style.display = 'none'
			}
		}, 100)
	}
	
}

// Global function to mark note as done - attach to window for onclick handlers
window.markNoteDone = function(noteId, button, event) {
	// Prevent event propagation to avoid opening the note
	if (event) {
		event.stopPropagation()
		event.preventDefault()
	}

	if (confirm('לסמן את המשימה כבוצעה?')) {
		fetch(`/notes/${noteId}/mark_done`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
			}
		}).then(response => {
			if (!response.ok) throw new Error('mark_done failed')

			button.disabled = true
			// The phone button is a check-mark icon only
			button.textContent = button.classList.contains('note-mark-done-mobile') ? '✓' : '✓ בוצע'
			button.classList.add('done')

			// Mark the note item as completed for every user viewing this desk
			const noteItem = button.closest('.note-item')
			if (noteItem) {
				noteItem.classList.add('note-completed')
				// Remove click action to prevent opening note after marking as done
				noteItem.removeAttribute('data-action')
				noteItem.style.cursor = 'default'
			}
		}).catch(() => {
			alert('שגיאה בסימון המשימה כבוצעה, נסו שוב')
		})
	}

	return false
}